import React from "react";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";
import RouteChoice from "../../../../ts/model-factory/basic/route/RouteChoice";
import RouteChoiceButton from "../../../element/button/RouteChoiceButton";
import StateViewController from "../../../vc/StateViewController";
import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import AccountPasswordResetForm from "../../../form/account/AccountPasswordResetForm";


const AccountPasswordResetPage = (props:IRouteProps) =>
{
    const viewState = StateViewController({
        routeProps: props
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }
    const accountModel = getModelFactory().accountRoute.getDefaultModel();
    const loginChoice: RouteChoice | null = accountModel.choices.login ?? null;

    return <>
        <section className="content-block">
            {!!loginChoice && <>

                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p>
                                Already know your password? Login <RouteChoiceButton routeChoice={loginChoice}>here</RouteChoiceButton>.
                            </p>
                        </div>
                    </div>
                </div>
            </>}
            <AccountPasswordResetForm
                routeProps={props}
            />
        </section>
    </>
}

export default AccountPasswordResetPage;